<template lang="pug">
  p.mb-0.text-help.text-sm El resultado estará disponible en la variable:
    span.text-primary.ml-1 {{ variableName }}
</template>

<script>
export default {
  props: {
    variableName: {
      type: String,
      default: ''
    },
    variableType: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
